
const state: any = {
  current: null
}

const getters = {
 
}

const mutations = {
  setCurrentUser(state: any, data: any) {
    state.current = data
  }
}

const actions = {
 
}

export default {
  state,
  getters,
  actions,
  mutations
}
